























































































import { Component } from 'vue-property-decorator'
import { mapState } from 'vuex'

import MatchMixin from '@/mixins/match'

@Component({
  computed: {
    // From root state
    ...mapState(['onLine']), // online status (connected to internet?)

    // From modules
    ...mapState('match', ['match', 'controlsLocked']), // map state-properties from 'match'-module
  },
})
export default class MatchView extends MatchMixin {
  isFullscreen = document.fullscreenElement !== null

  created(): void {
    document.addEventListener('fullscreenchange', () => {
      // document.addEventListener('fullscreenchange', (event) => {
      // console.log('Fullscreen changed event: ', event)
      // console.log('Fullscreen changed element: ', document.fullscreenElement)
      this.isFullscreen = document.fullscreenElement !== null
    })
  }

  /**
   * Determine whether device has enabled fullscreen functionality
   */
  get isFullscreenEnabled(): boolean {
    return document.fullscreenEnabled
  }

  // get isFullscreen(): boolean {
  //   console.log(document.fullscreenElement)
  //   return document.fullscreenElement !== null
  // }

  /**
   * Toggle controls lock
   */
  toggleControlsLock(): void {
    this.$store.commit('match/toggleControlsLock')
  }

  /**
   * Toggle full screen
   * Using the Fullscreen API
   * https://developer.mozilla.org/en-US/docs/Web/API/Fullscreen_API
   */
  toggleFullscreen(): void {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen()
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      }
    }
  }
}
